import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { unstable_batchedUpdates } from "react-dom";

import FrontPageLogo from "../../components/Logo/Logo";
import { GiEntryDoor } from "react-icons/gi";
import { Redirect, useHistory } from "react-router";
import { Trans, useTranslation } from "react-i18next";
import i18n, { t } from "i18next";
import QuestionHeader from "../AlternateQuestionHeader/AlternateQuestionHeader";
import Switch from "@mui/material/Switch";
import Feedback from "../../shared/api/FeedbackApi";

import IconButton from "@mui/material/IconButton";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import {
  InputLabel,
  FormControl,
  MenuItem,
  Autocomplete,
  AutocompleteChangeReason,
  Backdrop,
  Box,
  Button,
  Chip,
  ClickAwayListener,
  Dialog,
  Divider,
  Grid,
  Paper,
  Slider,
  Tab,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  useMediaQuery,
} from "@mui/material";
import _ from "underscore";
import CardDeck from "../CardDeck/CardDeck";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";

import PreviewCard from "../PreviewCard/PreviewCard";
import CardWarning from "../CardWarning/CardWarning";

import RefreshIcon from "@mui/icons-material/Refresh";
import {
  QuestionCardInfo,
  AnswerCardInfo,
  CardInfo,
  CardType,
  Language,
  CardDeckJSON,
  Question,
  Player,
} from "../../shared/interfaces/GameLogicTypes";
import {
  convertDimensionsToPixels,
  getElementHeight,
  getRandomTsarName,
  getLanguageByLanguageId,
} from "../../shared/helper/functions";
import CardCreationWidget from "../CardCreationWidget/CardCreationWidget";
import { Languages } from "../../shared/language/languages";
import { GameContext } from "../../shared/GameContext";
import { useAuth0 } from "@auth0/auth0-react";
import Deck from "../../shared/api/DeckApi";
import { publicWebUrl } from "../../shared/runtime";

import PlayerList from "../../components/PlayerList/PlayerList";
import InvitationLinkField from "../../components/InvitationLinkField/InvitationLinkField";

import { CSSProperties, FC } from "react";
import { DndProvider, useDrop } from "react-dnd";
import { useDrag } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ChoiceWidget from "../../components/ChoiceWidget/ChoiceWidget";
import SequenceBar from "../../components/SequenceBar/SequenceBar";
import ResultsSequence from "../../components/ResultsSequence/ResultsSequence";
import ResultsDialog from "../../components/ResultsDialog/ResultsDialog";

import {
  TurnInfo,
  Submissions,
  Results,
  PlayerEndResults,
  GameConfig,
  Cue,
  CueTypes,
  TurnMode,
  FtlStreakState,
  FtlTurnInfo,
  FtlStreakTurnResult,
  FtlStreakResults,
  FtlOption,
  ReverseRoundStartPayload,
  ReverseRoundGuessPhasePayload,
  ReverseRoundResultsPayload,
  HerdStreakState,
  HerdTurnInfo,
  HerdTurnResult,
  HerdStreakResults,
  PicassoStartPayload,
  PicassoImposterMission,
  PicassoGuessPhasePayload,
  PicassoResultsPayload,
  PicassoChallengeResult,
  StandardVersusResultsPayload,
} from "../../shared/interfaces/GameLogicTypes";
import FtlChoicePanel from "../FtlChoicePanel/FtlChoicePanel";
import ReverseRoundPanel from "../ReverseRoundPanel/ReverseRoundPanel";
import ReverseRoundResultsPanel from "../ReverseRoundResults/ReverseRoundResults";
import FtlStatusBar from "../FtlStatusBar/FtlStatusBar";
import FtlReveal from "../FtlReveal/FtlReveal";
import FtlStreakResultsPanel from "../FtlStreakResults/FtlStreakResults";
import HerdChoicePanel from "../HerdChoicePanel/HerdChoicePanel";
import HerdReveal from "../HerdReveal/HerdReveal";
import HerdStreakResultsPanel from "../HerdStreakResults/HerdStreakResults";
import VersusResultsPanel from "../VersusResults/VersusResults";
import PicassoCanvas, { PicassoCanvasHandle } from "../PicassoCanvas/PicassoCanvas";
import PicassoImposterReveal from "../PicassoImposterReveal/PicassoImposterReveal";
import PicassoResults from "../PicassoResults/PicassoResults";
// PicassoVotingReveal no longer used — flip happens in-place inside PicassoImposterReveal
// ReverseRoundReveal no longer used — flip happens in-place inside ReverseRoundPanel
import "./Game.css";

import { DragDropContext, DropResult } from "react-beautiful-dnd";
import useGameContext from "../../shared/useGameContext";
import useSocketContext from "../../shared/useSocketContext";
import PlayerCard from "../PlayerCard/PlayerCard";
import PlayerAvatar, { getPlayerColor } from "../PlayerAvatar/PlayerAvatar";
import { Theme as MuiTheme } from "@mui/material/styles";
import { useTheme } from "@emotion/react";
import MobileResults from "../MobileResults/MobileResults";
import TurnBurst from "../TurnBurst/TurnBurst";
import ReportPanel from "../ReportPanel/ReportPanel";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { FaCrown } from "react-icons/fa";
import { track } from "../../shared/analytics";
import useUiScale from "../../shared/helper/useUiScale";
import IntermissionPanel, {
  IntermissionPayload,
} from "../IntermissionPanel/IntermissionPanel";
declare module "@emotion/react" {
  export interface Theme extends MuiTheme {}
}

export interface GameProps {
  baseUrl: string;
  players: { [playerId: string]: Player };
  playerId: string;
  isHost: boolean;
  hostId: string;
  playerName: string;
  waitForHost: boolean;
  wasDCed: boolean;
  reconnectStatus: string;
  rejoin: () => void;
  readyPlayerIds: string[];
  isReady: boolean;
  onReadyToggle: (next: boolean) => void;
}

const shuffleArray = (arr: number[]): number[] => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

const reorder = (sequence: Array<number>, startIndex: number, endIndex: number) => {
  const result = Array.from(sequence);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export default function Game(props: GameProps) {
  //into Game Component
  const [turnPhase, setTurnPhase] = useState("S");
  const [tsarId, setTsarId] = useState("");
  const [isTsar, setIsTsar] = useState(false);
  const [tsarName, setTsarName] = useState("");
  const [question, setQuestion] = useState<Question>({ forTsar: "", aboutTsar: "" });
  const [results, setResults] = useState<Results>({});

  const defaultCue: Cue = { type: CueTypes.text, content: "" };
  const [cues, setCues] = useState<Cue[]>([defaultCue, defaultCue, defaultCue, defaultCue, defaultCue]);
  const cue1 = cues[0] ?? defaultCue;
  const cue2 = cues[1] ?? defaultCue;
  const cue3 = cues[2] ?? defaultCue;
  const cue4 = cues[3] ?? defaultCue;
  const cue5 = cues[4] ?? defaultCue;

  const [showLatestResults, setShowLatestResults] = useState(false);
  // Submission restored from the server after a reconnect/reload (see handleNewTurnInfo)
  const [restoredSubmitted, setRestoredSubmitted] = useState(false);
  const [turnNonce, setTurnNonce] = useState(0);
  const [sequenceEditVersion, setSequenceEditVersion] = useState(0);
  const restoredRef = useRef(false);
  const [timeLeft, setTimeLeft] = useState(-1);
  const [timeLimit, setTimeLimit] = useState(0);
  const [timerIsActive, setTimerIsActive] = useState(false);
  const [roundStart, setRoundStart] = useState(Date.now());

  const [roundLimit, setRoundLimit] = useState(0);

  const [currentRound, setCurrentRound] = useState(1);
  const [showIntro, setShowIntro] = useState(false);
  const [isShuffling, setIsShuffling] = useState(false);
  const [leaveDialogOpen, setLeaveDialogOpen] = useState(false);
  const [kickTarget, setKickTarget] = useState<string | null>(null);
  const [playersOpen, setPlayersOpen] = useState(false);
  const [isCodeVisible, setIsCodeVisible] = useState(false);
  const [linkCopied, setLinkCopied] = useState(false);
  const lobbyKey = useGameContext().lobbyKey;
  const inviteLink = publicWebUrl(`/join/${lobbyKey}`);
  const copyInviteLink = () => {
    navigator.clipboard.writeText(inviteLink);
    setLinkCopied(true);
    setTimeout(() => setLinkCopied(false), 2000);
  };
  const [sequence, setSequence] = useState<Array<number>>([]);
  const prevShowIntroRef = useRef(false);

  const [remainingSkips, setRemainingSkips] = useState(0);
  const [canSkip, setCanSkip] = useState(true);
  const Latest_Possible_Skip = 30;

  // ─── FTL State ─────────────────────────────────────────────────────────────
  const [initialStateReceived, setInitialStateReceived] = useState(false);
  const [turnMode, setTurnMode] = useState<TurnMode>(TurnMode.STANDARD);
  const [ftlStreakState, setFtlStreakState] = useState<FtlStreakState | null>(null);
  const [ftlChoice, setFtlChoice] = useState<number | null>(null);
  const [ftlCzarLocked, setFtlCzarLocked] = useState(false);
  const [ftlStreakResults, setFtlStreakResults] = useState<FtlStreakResults | null>(null);
  const [showFtlStreakResults, setShowFtlStreakResults] = useState(false);
  const [ftlTimeLeft, setFtlTimeLeft] = useState(-1);
  const [ftlTimerStart, setFtlTimerStart] = useState(0);
  const [ftlTimerLimit, setFtlTimerLimit] = useState(0);
  const ftlChoiceRef = useRef<number | null>(null);
  const [showFtlReveal, setShowFtlReveal] = useState(false);
  const [ftlTurnResultData, setFtlTurnResultData] = useState<FtlStreakTurnResult | null>(null);
  const ftlRevealChoiceRef = useRef<number | null>(null); // snapshot of choice at reveal time
  // Keep ref in sync
  useEffect(() => { ftlChoiceRef.current = ftlChoice; }, [ftlChoice]);

  // ─── Reverse Round State ──────────────────────────────────────────────────
  // ─── Intermission (admin broadcast between turns) ─────────────────────────
  const [intermission, setIntermission] = useState<IntermissionPayload | null>(null);
  const [intermissionAcks, setIntermissionAcks] = useState<string[]>([]);
  const [intermissionTotal, setIntermissionTotal] = useState(0);

  const [rrStage, setRrStage] = useState<1 | 2 | null>(null);
  const [rrQuestion, setRrQuestion] = useState<Question | null>(null);
  const [rrCues, setRrCues] = useState<Cue[]>([]);
  const [rrGuessPhase, setRrGuessPhase] = useState<ReverseRoundGuessPhasePayload | null>(null);
  const [rrResults, setRrResults] = useState<ReverseRoundResultsPayload | null>(null);
  const [showRrResults, setShowRrResults] = useState(false);
  const [rrHasSubmitted, setRrHasSubmitted] = useState(false);
  const [rrHasGuessed, setRrHasGuessed] = useState(false);
  const [rrHighRollDecided, setRrHighRollDecided] = useState(false);
  const [showRrReveal, setShowRrReveal] = useState(false);
  const rrGuessPhaseRef = useRef<ReverseRoundGuessPhasePayload | null>(null);
  const rrGuessRef = useRef<string | null>(null);
  // rrRevealDataRef removed — reveal now happens in-place in ReverseRoundPanel

  // ─── Herd State ──────────────────────────────────────────────────────────────
  const [herdStreakState, setHerdStreakState] = useState<HerdStreakState | null>(null);
  const [herdChoice, setHerdChoice] = useState<number | null>(null);
  const [herdStreakResults, setHerdStreakResults] = useState<HerdStreakResults | null>(null);
  const [showHerdStreakResults, setShowHerdStreakResults] = useState(false);
  const [showHerdReveal, setShowHerdReveal] = useState(false);
  const [herdTurnResultData, setHerdTurnResultData] = useState<HerdTurnResult | null>(null);
  const herdChoiceRef = useRef<number | null>(null);
  const herdRevealChoiceRef = useRef<number | null>(null);
  const [herdTimeLeft, setHerdTimeLeft] = useState(-1);
  const [herdTimerStart, setHerdTimerStart] = useState(0);
  const [herdTimerLimit, setHerdTimerLimit] = useState(0);
  useEffect(() => { herdChoiceRef.current = herdChoice; }, [herdChoice]);
  useEffect(() => { rrGuessPhaseRef.current = rrGuessPhase; }, [rrGuessPhase]);

  // ─── Standard-Versus State ───────────────────────────────────────────────────
  const [versusResults, setVersusResults] = useState<StandardVersusResultsPayload | null>(null);
  const [showVersusResults, setShowVersusResults] = useState(false);

  // ─── Picasso State ──────────────────────────────────────────────────────────
  const [picassoQuestion, setPicassoQuestion] = useState<Question | null>(null);
  const [picassoImposterMission, setPicassoImposterMission] = useState<PicassoImposterMission | null>(null);
  const [picassoImposterAccepted, setPicassoImposterAccepted] = useState<boolean | null>(null);
  const [picassoGuessAssignment, setPicassoGuessAssignment] = useState<PicassoGuessPhasePayload | null>(null);
  const [picassoResults, setPicassoResults] = useState<PicassoResultsPayload | null>(null);
  const [showPicassoResults, setShowPicassoResults] = useState(false);
  const [picassoStage, setPicassoStage] = useState<1 | 2 | null>(null);
  const picassoVoteRef = useRef<"A" | "B" | null>(null);
  const picassoCanvasRef = useRef<PicassoCanvasHandle>(null);
  const [picassoSubmittedIds, setPicassoSubmittedIds] = useState<string[]>([]);
  const [picassoCanvasKey, setPicassoCanvasKey] = useState(0);
  const [showPicassoReveal, setShowPicassoReveal] = useState(false);
  const picassoGuessAssignmentRef = useRef<PicassoGuessPhasePayload | null>(null);
  const picassoRevealDataRef = useRef<PicassoChallengeResult | null>(null);
  useEffect(() => { picassoGuessAssignmentRef.current = picassoGuessAssignment; }, [picassoGuessAssignment]);

  // ─── Vote Skip State ───────────────────────────────────────────────────────
  const [skipVoters, setSkipVoters] = useState<string[]>([]);
  // Votes the server needs to swap the question. Unanimous in small lobbies, lower in big ones,
  // so the button has to show the real target rather than assuming everyone must vote. 0 = not
  // yet received; fall back to the player count until it arrives.
  const [skipVotesNeeded, setSkipVotesNeeded] = useState(0);

  // ─── Report Panel State ────────────────────────────────────────────────────
  const [reportPanelOpen, setReportPanelOpen] = useState(false);
  const [reportAnchorEl, setReportAnchorEl] = useState<HTMLElement | null>(null);

  let theme = useTheme();
  let isMobile = useMediaQuery(theme.breakpoints.down("md"));
  // Pixel-sized artwork (avatars) has to be multiplied by hand; CSS lengths follow the root font.
  const uiScale = useUiScale();
  const socket = useSocketContext().socket;
  const history = useHistory();


  // ─── Cross-mode reset ────────────────────────────────────────────────────
  // Called at the start of every mode (including STANDARD) to clear stale state
  // from all other modes. Add new modes here when they're created.
  const resetAllModes = () => {
    // FTL
    setShowFtlStreakResults(false);
    setFtlStreakResults(null);
    setFtlStreakState(null);
    setShowFtlReveal(false);
    setFtlChoice(null);
    setFtlCzarLocked(false);
    setFtlTimeLeft(-1);
    setFtlTimerStart(0);
    setFtlTimerLimit(0);
    // Reverse Round
    setShowRrResults(false);
    setShowRrReveal(false);
    setRrResults(null);
    setRrStage(null);
    setRrGuessPhase(null);
    setRrHasSubmitted(false);
    setRrHasGuessed(false);
    setRrHighRollDecided(false);
    // Herd
    setShowHerdStreakResults(false);
    setHerdStreakResults(null);
    setHerdStreakState(null);
    setShowHerdReveal(false);
    setHerdChoice(null);
    setHerdTimeLeft(-1);
    setHerdTimerStart(0);
    setHerdTimerLimit(0);
    // Picasso
    setShowPicassoResults(false);
    setShowPicassoReveal(false);
    setPicassoResults(null);
    setPicassoStage(null);
    setPicassoGuessAssignment(null);
    // Standard-Versus
    setShowVersusResults(false);
    setVersusResults(null);
    // Shared timer (Standard / RR / Picasso)
    setTimerIsActive(false);
    setTimeLeft(-1);
    setTimeLimit(0);
    // Standard
    setShowLatestResults(false);
    // Report panel
    setReportPanelOpen(false);
    setReportAnchorEl(null);
    // Reset scroll position on mobile
    document.getElementById("box1")?.scrollTo(0, 0);
  };

  //adding socket listeners
  useEffect(() => {
    // Named handlers so cleanup only removes Game.tsx's own listeners,
    // leaving Lobby.tsx's listeners (e.g. setIsReady(false)) intact.
    const onSkipped = () => { reset(); };
    const onTurnPhase = (turnPhase: string) => {
      setTurnPhase(turnPhase);
    };
    const onCanSkip = (canSkip: boolean) => { setCanSkip(canSkip); };
    const onResults = (results: Results) => {
      if (!results || Object.keys(results).length === 0) return;
      handleNewResults(results);
    };
    const onTurnInfo = (turnInfo: TurnInfo) => {
      setInitialStateReceived(true);
      handleNewTurnInfo(turnInfo);
    };
    const onCurrentRound = (currentRound: number) => { setCurrentRound(currentRound); };
    const onRoundLimit = (v: number) => setRoundLimit(v);

    // ─── FTL socket handlers ──────────────────────────────────────────────────
    const onFtlStreakStart = (state: FtlStreakState) => {
      unstable_batchedUpdates(() => {
        resetAllModes();
        setInitialStateReceived(true);
        setTurnMode(TurnMode.FOLLOW_THE_LEADER);
        setFtlStreakState(state);

        // Show TurnBurst for first turn
        if (state.streakIndex === 0) {
          setTsarId(state.czarId);
          setShowIntro(true);
        }
      });
    };
    const onFtlTurnInfo = (info: FtlTurnInfo) => {
      unstable_batchedUpdates(() => {
        setShowFtlReveal(false);
        setFtlTurnResultData(null);
        setSkipVoters([]);
        setFtlStreakState((prev) =>
          prev ? { ...prev, ...info } : null
        );
        setFtlChoice(null);
        setFtlCzarLocked(false);
        setFtlTimerStart(info.startTime);
        setFtlTimerLimit(info.timer);
        setFtlTimeLeft(Math.max(0, info.timer - Math.round((Date.now() - info.startTime) / 1000)));
        // Update question for display
        setQuestion(info.question as any);
      });
    };
    const onFtlCzarLocked = () => {
      setFtlCzarLocked(true);
    };
    const onFtlTurnResult = (result: FtlStreakTurnResult) => {
      // Snapshot the player's choice before it gets reset
      ftlRevealChoiceRef.current = ftlChoiceRef.current;
      setFtlTurnResultData(result);
      setShowFtlReveal(true);
      // Update alive/dead in streak state
      setFtlStreakState((prev) => {
        if (!prev) return null;
        return {
          ...prev,
          alivePlayers: result.survivors,
          deadPlayers: [...prev.deadPlayers, ...result.eliminations],
          czarChoice: result.czarChoice,
          multiplier: result.multiplier,
        };
      });
    };
    const onFtlStreakEnd = (results: FtlStreakResults) => {
      setFtlStreakResults(results);
      setShowFtlStreakResults(true);
      setTurnMode(TurnMode.STANDARD);
    };
    const onFtlForceSubmit = () => {
      // Auto-submit current choice if any
      const currentChoice = ftlChoiceRef.current;
      if (currentChoice !== null) {
        socket.emit("ftlSubmit", currentChoice);
      }
    };
    const onFtlStreakAborted = () => {
      unstable_batchedUpdates(() => {
        setTurnMode(TurnMode.STANDARD);
        setFtlStreakState(null);
        setFtlChoice(null);
        setFtlCzarLocked(false);
        setShowFtlStreakResults(false);
      });
    };

    // ─── Reverse Round socket handlers ──────────────────────────────────────────
    const onReverseRoundStart = (payload: ReverseRoundStartPayload) => {
      unstable_batchedUpdates(() => {
        resetAllModes();
        setInitialStateReceived(true);
        setTurnMode(TurnMode.REVERSE_ROUND);
        setRrStage(1);
        setRrQuestion(payload.question);
        setRrCues(payload.cues);
        // Server tells us whether we already submitted (reconnect/reload resync)
        setRrHasSubmitted(!!payload.hasSubmitted);

        setTimerIsActive(true);
        setTimeLimit(payload.timer);
        setRoundStart(payload.startTime);
        setTimeLeft(Math.max(0, payload.timer - Math.round((Date.now() - payload.startTime) / 1000)));
        setShowIntro(true);
      });
    };
    const onReverseRoundGuessPhase = (payload: ReverseRoundGuessPhasePayload) => {
      unstable_batchedUpdates(() => {
        setRrStage(2);
        setRrGuessPhase(payload);
        // Server tells us whether we already guessed (reconnect/reload resync)
        setRrHasGuessed(!!payload.hasGuessed);
        setTimerIsActive(true);
        setTimeLimit(payload.timer);
        setRoundStart(payload.startTime);
        setTimeLeft(Math.max(0, payload.timer - Math.round((Date.now() - payload.startTime) / 1000)));
        setShowIntro(true);
      });
    };
    const onReverseRoundForceSubmit = () => {
    };
    const onReverseRoundForceGuess = () => {
    };
    const onReverseRoundResults = (results: ReverseRoundResultsPayload) => {
      const guessPhase = rrGuessPhaseRef.current;
      const playerGuess = rrGuessRef.current;
      if (guessPhase && playerGuess !== null) {
        // Keep rrStage=2 so the panel stays mounted with the sequence bar;
        // pass results to trigger the in-place flip animation
        setRrResults(results);
        setShowRrReveal(true);
      } else {
        setRrResults(results);
        setRrStage(null);
        setShowRrResults(true);
        setTurnMode(TurnMode.STANDARD);
      }
      setTimerIsActive(false);
    };

    // ─── Herd Handlers ──────────────────────────────────────────────────────────
    const onHerdStreakStart = (state: HerdStreakState) => {
      unstable_batchedUpdates(() => {
        resetAllModes();
        setInitialStateReceived(true);
        setTurnMode(TurnMode.RUN_WITH_THE_HERD);
        setHerdStreakState(state);

        if (state.streakIndex === 0) {
          setShowIntro(true);
        }
      });
    };

    const onHerdTurnInfo = (info: HerdTurnInfo) => {
      unstable_batchedUpdates(() => {
        setShowHerdReveal(false);
        setHerdTurnResultData(null);
        setSkipVoters([]);
        setHerdStreakState((prev) =>
          prev ? { ...prev, ...info } : null
        );
        setHerdChoice(null);
        setHerdTimerStart(info.startTime);
        setHerdTimerLimit(info.timer);
        setHerdTimeLeft(Math.max(0, info.timer - Math.round((Date.now() - info.startTime) / 1000)));
      });
    };

    const onHerdTurnResult = (result: HerdTurnResult) => {
      herdRevealChoiceRef.current = herdChoiceRef.current;
      setHerdTurnResultData(result);
      setShowHerdReveal(true);
      setHerdStreakState((prev) => {
        if (!prev) return null;
        return {
          ...prev,
          alivePlayers: result.survivors,
          deadPlayers: [...prev.deadPlayers, ...result.eliminations],
        };
      });
    };

    const onHerdStreakEnd = (results: HerdStreakResults) => {
      setHerdStreakResults(results);
      setShowHerdStreakResults(true);
      setTurnMode(TurnMode.STANDARD);
    };

    const onHerdForceSubmit = () => {
      const currentChoice = herdChoiceRef.current;
      if (currentChoice !== null) {
        socket.emit("herdSubmit", currentChoice);
      }
    };

    const onHerdStreakAborted = () => {
      unstable_batchedUpdates(() => {
        setTurnMode(TurnMode.STANDARD);
        setHerdStreakState(null);
        setHerdChoice(null);
        setShowHerdStreakResults(false);
      });
    };

    // ─── Standard-Versus Handlers ────────────────────────────────────────────────
    const onStandardVersusResults = (payload: StandardVersusResultsPayload) => {
      unstable_batchedUpdates(() => {
        setInitialStateReceived(true);
        setTurnMode(TurnMode.STANDARD_VERSUS);
        setVersusResults(payload);
        setShowVersusResults(true);
        setShowLatestResults(false);
        setShowIntro(false);
        setTimerIsActive(false);
      });
    };

    // ─── Picasso Handlers ──────────────────────────────────────────────────────
    const onPicassoStart = (payload: PicassoStartPayload) => {
      unstable_batchedUpdates(() => {
        resetAllModes();
        setInitialStateReceived(true);
        setTurnMode(TurnMode.PICASSO);
        setPicassoQuestion(payload.question);
        setPicassoStage(1);
        setPicassoImposterMission(null);
        setPicassoImposterAccepted(null);
        setPicassoSubmittedIds([]);
        setPicassoCanvasKey((k) => k + 1);
        // Timer
        setTimerIsActive(true);
        setTimeLimit(payload.timer);
        setRoundStart(payload.startTime);
        setTimeLeft(Math.max(0, payload.timer - Math.round((Date.now() - payload.startTime) / 1000)));
        setShowIntro(true);
      });
    };
    const onPicassoImposterMission = (mission: PicassoImposterMission) => {
      setPicassoImposterMission(mission);
    };
    const onPicassoSubmittedIds = (ids: string[]) => {
      setPicassoSubmittedIds(ids);
    };
    const onPicassoForceSubmitDrawing = () => {
      picassoCanvasRef.current?.forceExport();
    };
    const onPicassoGuessPhase = (payload: PicassoGuessPhasePayload) => {
      picassoVoteRef.current = null;
      unstable_batchedUpdates(() => {
        setPicassoStage(2);
        setPicassoGuessAssignment(payload);
        setTimerIsActive(true);
        setTimeLimit(payload.timer);
        setRoundStart(payload.startTime);
        setTimeLeft(Math.max(0, payload.timer - Math.round((Date.now() - payload.startTime) / 1000)));
      });
    };
    const onPicassoForceVote = () => {
      const currentVote = picassoVoteRef.current;
      if (currentVote !== null) {
        socket.emit("picassoVote", { vote: currentVote });
      }
    };
    const onPicassoResults = (payload: PicassoResultsPayload) => {
      const guessData = picassoGuessAssignmentRef.current;
      const vote = picassoVoteRef.current;
      if (guessData && vote !== null) {
        // Find the matching challenge result by comparing drawings
        const matchedResult = payload.challengeResults.find(
          (cr) => cr.drawingA === guessData.drawingA && cr.drawingB === guessData.drawingB
        ) ?? null;
        // Keep picassoGuessAssignment so the voting panel stays mounted for in-place flip
        setPicassoResults(payload);
        picassoRevealDataRef.current = matchedResult;
        setShowPicassoReveal(true);
      } else {
        setPicassoResults(payload);
        setPicassoStage(null);
        setPicassoGuessAssignment(null);
        setTurnMode(TurnMode.STANDARD);
        setShowPicassoResults(true);
      }
      setTimerIsActive(false);
    };

    socket.on("skipped", onSkipped);
    socket.on("turnPhase", onTurnPhase);
    socket.on("canSkip", onCanSkip);
    socket.on("results", onResults);
    socket.on("turnInfo", onTurnInfo);
    socket.on("currentRound", onCurrentRound);
    socket.on("roundLimit", onRoundLimit);
    socket.on("ftlStreakStart", onFtlStreakStart);
    socket.on("ftlTurnInfo", onFtlTurnInfo);
    socket.on("ftlCzarLocked", onFtlCzarLocked);
    socket.on("ftlTurnResult", onFtlTurnResult);
    socket.on("ftlStreakEnd", onFtlStreakEnd);
    socket.on("ftlForceSubmit", onFtlForceSubmit);
    socket.on("ftlStreakAborted", onFtlStreakAborted);
    socket.on("reverseRoundStart", onReverseRoundStart);
    socket.on("reverseRoundGuessPhase", onReverseRoundGuessPhase);
    socket.on("reverseRoundForceSubmit", onReverseRoundForceSubmit);
    socket.on("reverseRoundForceGuess", onReverseRoundForceGuess);
    socket.on("reverseRoundResults", onReverseRoundResults);
    socket.on("herdStreakStart", onHerdStreakStart);
    socket.on("herdTurnInfo", onHerdTurnInfo);
    socket.on("herdTurnResult", onHerdTurnResult);
    socket.on("herdStreakEnd", onHerdStreakEnd);
    socket.on("herdForceSubmit", onHerdForceSubmit);
    socket.on("herdStreakAborted", onHerdStreakAborted);
    socket.on("standardVersusResults", onStandardVersusResults);
    socket.on("picassoStart", onPicassoStart);
    socket.on("picassoImposterMission", onPicassoImposterMission);
    socket.on("picassoSubmittedIds", onPicassoSubmittedIds);
    socket.on("picassoForceSubmitDrawing", onPicassoForceSubmitDrawing);
    socket.on("picassoGuessPhase", onPicassoGuessPhase);
    socket.on("picassoForceVote", onPicassoForceVote);
    socket.on("picassoResults", onPicassoResults);
    const onSkipVoters = (voters: string[]) => setSkipVoters(voters);
    socket.on("skipVoters", onSkipVoters);
    const onIntermissionStart = (payload: IntermissionPayload) => {
      setIntermission(payload);
      setIntermissionAcks([]);
    };
    const onIntermissionAcks = (p: { acknowledged: string[]; total: number }) => {
      setIntermissionAcks(p.acknowledged ?? []);
      setIntermissionTotal(p.total ?? 0);
    };
    const onIntermissionEnd = () => {
      setIntermission(null);
      setIntermissionAcks([]);
      setIntermissionTotal(0);
    };
    socket.on("intermissionStart", onIntermissionStart);
    socket.on("intermissionAcks", onIntermissionAcks);
    socket.on("intermissionEnd", onIntermissionEnd);
    const onSkipVotesNeeded = (needed: number) => setSkipVotesNeeded(needed);
    socket.on("skipVotesNeeded", onSkipVotesNeeded);
    socket.emit("refresh");

    return () => {
      socket.off("skipped", onSkipped);
      socket.off("turnPhase", onTurnPhase);
      socket.off("canSkip", onCanSkip);
      socket.off("results", onResults);
      socket.off("turnInfo", onTurnInfo);
      socket.off("currentRound", onCurrentRound);
      socket.off("roundLimit", onRoundLimit);
      socket.off("ftlStreakStart", onFtlStreakStart);
      socket.off("ftlTurnInfo", onFtlTurnInfo);
      socket.off("ftlCzarLocked", onFtlCzarLocked);
      socket.off("ftlTurnResult", onFtlTurnResult);
      socket.off("ftlStreakEnd", onFtlStreakEnd);
      socket.off("ftlForceSubmit", onFtlForceSubmit);
      socket.off("ftlStreakAborted", onFtlStreakAborted);
      socket.off("reverseRoundStart", onReverseRoundStart);
      socket.off("reverseRoundGuessPhase", onReverseRoundGuessPhase);
      socket.off("reverseRoundForceSubmit", onReverseRoundForceSubmit);
      socket.off("reverseRoundForceGuess", onReverseRoundForceGuess);
      socket.off("reverseRoundResults", onReverseRoundResults);
      socket.off("herdStreakStart", onHerdStreakStart);
      socket.off("herdTurnInfo", onHerdTurnInfo);
      socket.off("herdTurnResult", onHerdTurnResult);
      socket.off("herdStreakEnd", onHerdStreakEnd);
      socket.off("herdForceSubmit", onHerdForceSubmit);
      socket.off("herdStreakAborted", onHerdStreakAborted);
      socket.off("standardVersusResults", onStandardVersusResults);
      socket.off("picassoStart", onPicassoStart);
      socket.off("picassoImposterMission", onPicassoImposterMission);
      socket.off("picassoSubmittedIds", onPicassoSubmittedIds);
      socket.off("picassoForceSubmitDrawing", onPicassoForceSubmitDrawing);
      socket.off("picassoGuessPhase", onPicassoGuessPhase);
      socket.off("picassoForceVote", onPicassoForceVote);
      socket.off("picassoResults", onPicassoResults);
      socket.off("skipVoters", onSkipVoters);
      socket.off("intermissionStart", onIntermissionStart);
      socket.off("intermissionAcks", onIntermissionAcks);
      socket.off("intermissionEnd", onIntermissionEnd);
      socket.off("skipVotesNeeded", onSkipVotesNeeded);
    };
  }, []);

  const handleNewTurnInfo = (turnInfo: TurnInfo) => {
    unstable_batchedUpdates(() => {
    resetAllModes();
    // STANDARD_VERSUS reuses turnInfo for its submission phase (everyone ranks the same
    // forTsar question); only the mode tag distinguishes it from co-op STANDARD.
    setTurnMode(turnInfo.turnMode === TurnMode.STANDARD_VERSUS ? TurnMode.STANDARD_VERSUS : TurnMode.STANDARD);

    setRoundStart(turnInfo["startTime"]);
    setTimeLimit(turnInfo["timer"]);
    setTimeLeft(Math.max(0, turnInfo.timer - Math.round((Date.now() - turnInfo.startTime) / 1000)));
    setTimerIsActive(true);

    setRoundLimit(turnInfo["roundLimit"]);
    setTsarId(turnInfo["tsarId"]);
    setQuestion(turnInfo["question"]);

    turnInfo["cues"].forEach((cue) => {
      if (cue.type === CueTypes.image) {
        cue.content = props.baseUrl + cue.content;
      }
    });

    setCues(turnInfo["cues"]);

    // Restore an already-given answer after a reconnect/reload — turnInfo embeds
    // all submissions, so a re-push of the current turn carries ours. A genuinely
    // new turn (or a skip, which also re-emits turnInfo) has no submissions yet,
    // so this is a no-op there — and deliberately does NOT remount the
    // SequenceBar, since that would cut off the skip/shuffle animation.
    const mySub = turnInfo.submissions?.[props.playerId];
    const restored = !!mySub && mySub.length === 5;
    restoredRef.current = restored;
    setRestoredSubmitted(restored);
    if (restored) {
      setSequence([...mySub!]);
      // Force-remount the SequenceBar so it picks up initialSubmitted=true even
      // if it already mounted (with the not-yet-restored default) moments earlier
      // in the same reconnect — setState calls from socket handlers aren't
      // auto-batched across the two socket.on callbacks in React 17.
      setTurnNonce((n) => n + 1);
    }
    });
  };

  useEffect(() => {
    if (props.playerId != "") {
      setRemainingSkips(props.players[props.playerId]?.remainingSkips);
    }
  }, [props.players]);

  const handleNewResults = (results: Results) => {
    setResults(results);
    setTurnPhase("R");
    setShowIntro(false);
  };

  const handleNewPlayers = () => {};

  const onSequenceDragStart = useCallback(() => {
    if (turnMode === TurnMode.STANDARD || turnMode === TurnMode.STANDARD_VERSUS) {
      // Withdraw at drag start, not after React applies the reordered sequence.
      // This prevents another player's final submission from closing the turn
      // while this player is actively changing a previously locked ranking.
      socket.emit("unsubmit");
      setSequenceEditVersion((version) => version + 1);
    }
  }, [socket, turnMode]);

  const onDragEnd = useCallback((result: DropResult) => {
    if (!result.destination || result.destination?.droppableId !== "sequenceBar") {
      return;
    }
    if (
      result.source.droppableId === "sequenceBar" &&
      result.source.index !== result.destination.index
    ) {
      setSequence((prev) => reorder(prev, result.source.index, result.destination!.index));
    }
  }, []);

  useEffect(() => {
    if (turnPhase == "S") {
      setShowLatestResults(false);
      setTimerIsActive(true);
    } else if (turnPhase == "R") {
      // Versus shows its own reveal/results panel (driven by standardVersusResults), never the
      // standard results view.
      if (turnMode !== TurnMode.STANDARD_VERSUS) setShowLatestResults(true);
      setTimerIsActive(false);
    }
  }, [turnPhase]);

  //timer controller
  useEffect(() => {
    var intervalId: NodeJS.Timeout;
    if (timerIsActive) {
      // exit early when we reach 0
      if (!timeLeft) return;
      // save intervalId to clear the interval when the
      // component re-renders
      intervalId = setInterval(() => {
        setTimeLeft(Math.max(0, timeLimit - Math.floor((Date.now() - roundStart) / 1000)));
      }, 1000);
    }
    // clear interval on re-render to avoid memory leaks
    return () => clearInterval(intervalId);
  }, [timerIsActive, timeLimit, roundStart]);

  useEffect(() => {
    if (!tsarName) return; // skip initial empty render
    setShowIntro(true);
    // Safety fallback: auto-dismiss after 5 s in case the 3 s TurnBurst timer doesn't fire
    const safetyId = setTimeout(() => setShowIntro(false), 5000);
    return () => clearTimeout(safetyId);
  }, [tsarName]);

  //new Tsar means new round
  useEffect(() => {
    setTurnPhase("S");
    setCanSkip(true);
  }, [tsarId]);

  useEffect(() => {
    if (tsarId === "") {
      setIsTsar(false);
      setTsarName("");
      return;
    }
    let tsarInfo = props.players[tsarId];
    setIsTsar(tsarId === props.playerId);
    if (tsarInfo != undefined) {
      setTsarName(tsarInfo["name"]);
    }
  }, [tsarId, props.playerId]);

  // Two-step shuffle for skip/manual reset (plays immediately, no Lock In disable)
  const reset = () => {
    setSequence(shuffleArray([1, 2, 3, 4, 5]));
    setTimeout(() => setSequence(shuffleArray([1, 2, 3, 4, 5])), 700);
  };

  // Animated shuffle used at turn start. Disables Lock In for 1400 ms.
  const playShuffleAnimation = () => {
    setIsShuffling(true);
    setSequence(shuffleArray([1, 2, 3, 4, 5]));
    setTimeout(() => {
      setSequence(shuffleArray([1, 2, 3, 4, 5]));
      setTimeout(() => setIsShuffling(false), 700);
    }, 700);
  };

  // When the intro dialog closes, play the shuffle animation
  // (not when a submitted sequence was restored after a reconnect — don't overwrite it)
  useEffect(() => {
    if (prevShowIntroRef.current && !showIntro) {
      if (!restoredRef.current) playShuffleAnimation();
    }
    prevShowIntroRef.current = showIntro;
  }, [showIntro]);

  const handleDecreaseRemainingSkips = useCallback(() => {
    setRemainingSkips((prev) => prev - 1);
  }, []);

  useEffect(() => {
    // Set initial sequence silently; animation fires when intro dialog closes.
    // Skipped when a submitted sequence was restored after a reconnect.
    if (restoredRef.current) return;
    setSequence(shuffleArray([1, 2, 3, 4, 5]));
  }, [tsarId]);

  // ─── FTL Timer ──────────────────────────────────────────────────────────────
  const [ftlCzarCountdown, setFtlCzarCountdown] = useState(7);
  useEffect(() => {
    if (turnMode !== TurnMode.FOLLOW_THE_LEADER || ftlTimerLimit <= 0) return;
    const intervalId = setInterval(() => {
      setFtlTimeLeft(Math.max(0, ftlTimerLimit - Math.floor((Date.now() - ftlTimerStart) / 1000)));
    }, 1000);
    return () => clearInterval(intervalId);
  }, [turnMode, ftlTimerLimit, ftlTimerStart]);

  // 7s czar-locked countdown
  useEffect(() => {
    if (!ftlCzarLocked) { setFtlCzarCountdown(7); return; }
    setFtlCzarCountdown(7);
    const id = setInterval(() => setFtlCzarCountdown((c) => Math.max(0, c - 1)), 1000);
    return () => clearInterval(id);
  }, [ftlCzarLocked]);

  // ─── FTL Selection Handler ─────────────────────────────────────────────────
  const isTsarRef = useRef(isTsar);
  useEffect(() => { isTsarRef.current = isTsar; }, [isTsar]);

  const handleFtlSelect = useCallback((choice: number) => {
    track("ftl_choice", { isCzar: isTsarRef.current });
    if (isTsarRef.current) {
      socket.emit("ftlSubmit", choice);
      setFtlChoice(choice);
    } else {
      if (ftlChoiceRef.current === choice) {
        setFtlChoice(null);
        socket.emit("ftlUnsubmit");
      } else {
        setFtlChoice(choice);
        socket.emit("ftlSubmit", choice);
      }
    }
  }, [socket]);

  // Whether this player is alive in the current FTL streak
  const ftlIsAlive = ftlStreakState
    ? ftlStreakState.alivePlayers.includes(props.playerId) || ftlStreakState.czarId === props.playerId
    : false;

  // ─── FTL render helper ─────────────────────────────────────────────────────
  const renderFtlPanel = (mobile?: boolean) => {
    if (!ftlStreakState) return null;

    // Status text — always occupies the same slot so layout never shifts
    const ftlStatusText = !ftlIsAlive ? (
      <Typography variant="body2" color="text.secondary" textAlign="center">
        You were eliminated. Spectating...
      </Typography>
    ) : isTsar ? (
      <Typography variant="body2" color="text.secondary" textAlign="center">
        {ftlChoice === null
          ? "Choose your answer — the others will try to follow!"
          : "Your choice is locked in. Waiting for others..."}
      </Typography>
    ) : (
      // Invisible spacer — same text as czar so height always matches
      <Typography variant="body2" textAlign="center" sx={{ visibility: "hidden" }}>
        Choose your answer — the others will try to follow!
      </Typography>
    );

    // Reveal phase: show card flip
    if (showFtlReveal && ftlTurnResultData) {
      return (
        <Stack spacing={3} sx={{ width: "100%" }}>
          <FtlReveal
            options={ftlStreakState.options}
            czarChoice={ftlTurnResultData.czarChoice}
            playerChoice={ftlRevealChoiceRef.current}
            isCzar={isTsar}
            isAlive={ftlIsAlive}
            eliminations={ftlTurnResultData.eliminations}
            playerId={props.playerId}
            onAnimationComplete={() => setShowFtlReveal(false)}
          />
          <FtlStatusBar
            alivePlayers={ftlStreakState.alivePlayers}
            deadPlayers={ftlStreakState.deadPlayers}
            players={props.players}
            multiplier={ftlStreakState.multiplier}
            isMobile={mobile}
            streakIndex={ftlStreakState.streakIndex}
          />
          {ftlStatusText}
        </Stack>
      );
    }

    // Normal choice phase
    return (
      <Stack spacing={3} sx={{ width: "100%" }}>
        <FtlChoicePanel
          options={ftlStreakState.options}
          isCzar={isTsar}
          isAlive={ftlIsAlive}
          selectedChoice={ftlChoice}
          onSelect={handleFtlSelect}
          czarLocked={ftlCzarLocked}
          timeLeft={ftlTimeLeft}
          isMobile={mobile}
        />
        <FtlStatusBar
          alivePlayers={ftlStreakState.alivePlayers}
          deadPlayers={ftlStreakState.deadPlayers}
          players={props.players}
          multiplier={ftlStreakState.multiplier}
          isMobile={mobile}
          streakIndex={ftlStreakState.streakIndex}
        />
        {ftlStatusText}
      </Stack>
    );
  };

  // ─── Herd Timer ───────────────────────────────────────────────────────────────
  useEffect(() => {
    if (turnMode !== TurnMode.RUN_WITH_THE_HERD || herdTimerLimit <= 0) return;
    const intervalId = setInterval(() => {
      setHerdTimeLeft(Math.max(0, herdTimerLimit - Math.floor((Date.now() - herdTimerStart) / 1000)));
    }, 1000);
    return () => clearInterval(intervalId);
  }, [turnMode, herdTimerLimit, herdTimerStart]);

  // ─── Herd Selection Handler ─────────────────────────────────────────────────
  const handleHerdSelect = useCallback((choice: number) => {
    track("herd_choice", {});
    if (herdChoiceRef.current === choice) {
      setHerdChoice(null);
      socket.emit("herdUnsubmit");
    } else {
      setHerdChoice(choice);
      socket.emit("herdSubmit", choice);
    }
  }, [socket]);

  const herdIsAlive = herdStreakState
    ? herdStreakState.alivePlayers.includes(props.playerId)
    : false;

  // ─── Herd render helper ─────────────────────────────────────────────────────
  const renderHerdPanel = (mobile?: boolean) => {
    if (!herdStreakState) return null;

    // Reveal phase
    if (showHerdReveal && herdTurnResultData) {
      return (
        <Stack spacing={3} sx={{ width: "100%" }}>
          <HerdReveal
            options={herdTurnResultData.options}
            optionCounts={herdTurnResultData.optionCounts}
            playerChoice={herdRevealChoiceRef.current}
            isAlive={herdIsAlive}
            wasSplit={herdTurnResultData.wasSplit}
            eliminations={herdTurnResultData.eliminations}
            playerId={props.playerId}
            onAnimationComplete={() => setShowHerdReveal(false)}
          />
          <FtlStatusBar
            alivePlayers={herdStreakState.alivePlayers}
            deadPlayers={herdStreakState.deadPlayers}
            players={props.players}
            multiplier={1}
            isMobile={mobile}
            streakIndex={herdStreakState.streakIndex}
            aliveLabel="Running"
            deadLabel="Trampled"
          />
        </Stack>
      );
    }

    // Choice phase
    return (
      <Stack spacing={3} sx={{ width: "100%" }}>
        <HerdChoicePanel
          options={herdStreakState.options}
          selectedChoice={herdChoice}
          onSelect={handleHerdSelect}
          isAlive={herdIsAlive}
          isMobile={mobile}
          timeLeft={herdTimeLeft}
        />
        <FtlStatusBar
          alivePlayers={herdStreakState.alivePlayers}
          deadPlayers={herdStreakState.deadPlayers}
          players={props.players}
          multiplier={1}
          isMobile={mobile}
          streakIndex={herdStreakState.streakIndex}
          aliveLabel="Running"
          deadLabel="Trampled"
        />
      </Stack>
    );
  };

  // ─── Reverse Round render helper ────────────────────────────────────────────
  const rrHasSubmittedRef = useRef(rrHasSubmitted);
  useEffect(() => { rrHasSubmittedRef.current = rrHasSubmitted; }, [rrHasSubmitted]);

  const handleRrSubmit = useCallback((seq: number[]) => {
    if (!rrHasSubmittedRef.current) {
      track("rr_submit");
      socket.emit("reverseRoundSubmit", { sequence: seq });
      setRrHasSubmitted(true);
    }
  }, [socket]);

  const renderRrPanel = (mobile?: boolean) => {
    if (rrStage === 1) {
      // Reuse the standard SequenceBar for drag-and-drop ranking
      return (
        <SequenceBar
          key={"rrsb-" + (rrHasSubmitted ? 1 : 0)}
          sequence={sequence}
          remainingSkips={rrHasSubmitted ? 0 : 1}
          reset={() => reset()}
          canSkip={!rrHasSubmitted}
          decreaseRemainingSkips={() => {}}
          onSkip={() => socket.emit(hasVotedSkip ? "voteUnSkip" : "voteSkip")}
          skipLabel={hasVotedSkip
            ? `Skip ✓ (${skipVoters.length}/${skipVotesTarget})`
            : `Skip (${skipVoters.length}/${skipVotesTarget})`}
          cue1={rrCues[0] ?? cue1}
          cue2={rrCues[1] ?? cue2}
          cue3={rrCues[2] ?? cue3}
          cue4={rrCues[3] ?? cue4}
          cue5={rrCues[4] ?? cue5}
          isMobile={mobile}
          isShuffling={isShuffling}
          onSubmit={handleRrSubmit}
          forceSubmitEvent="reverseRoundForceSubmit"
          initialSubmitted={rrHasSubmitted}
        />
      );
    }
    if (rrStage === 2) {
      return (
        <ReverseRoundPanel
          stage={2}
          cues={rrCues}
          guessPhase={rrGuessPhase ?? undefined}
          onGuess={(guessedId) => {
            track("rr_guess");
            rrGuessRef.current = guessedId;
            socket.emit("reverseRoundGuess", { guessedId });
            setRrHasGuessed(true);
          }}
          onHighRoll={(accepted) => {
            track("rr_high_roll", { accepted });
            socket.emit("reverseRoundHighRoll", { accepted });
            setRrHighRollDecided(true);
          }}
          hasGuessed={rrHasGuessed}
          highRollDecided={rrHighRollDecided}
          isMobile={mobile}
          revealResults={showRrReveal ? rrResults : null}
          playerId={props.playerId}
          onRevealComplete={() => {
            setShowRrReveal(false);
            setRrStage(null);
            setTurnMode(TurnMode.STANDARD);
            setShowRrResults(true);
          }}
        />
      );
    }
    return null;
  };

  const totalPlayers = Object.keys(props.players).length;
  const hasVotedSkip = skipVoters.includes(props.playerId);
  const skipVotesTarget = skipVotesNeeded > 0 ? Math.min(skipVotesNeeded, totalPlayers) : totalPlayers;

  const voteSkipBtn = (
    <Button
      size="small"
      variant={hasVotedSkip ? "contained" : "outlined"}
      color="secondary"
      onClick={() => socket.emit(hasVotedSkip ? "voteUnSkip" : "voteSkip")}
      sx={{ alignSelf: "center", minWidth: 110, mt: 0.5 }}
    >
      {hasVotedSkip
        ? `Skip ✓ (${skipVoters.length}/${skipVotesTarget})`
        : `Skip (${skipVoters.length}/${skipVotesTarget})`}
    </Button>
  );

  const herdSkipBtn = (
    <Button
      size="small"
      variant="contained"
      color="secondary"
      disabled={showHerdReveal}
      onClick={() => socket.emit(hasVotedSkip ? "voteUnSkip" : "voteSkip")}
      sx={{ alignSelf: "center", minWidth: 110, mt: 0.5 }}
    >
      {hasVotedSkip
        ? `Skip ✓ (${skipVoters.length}/${skipVotesTarget})`
        : `Skip (${skipVoters.length}/${skipVotesTarget})`}
    </Button>
  );

  const ftlRemainingSkips = props.players[props.playerId]?.remainingSkips ?? 0;
  const ftlCzarSkipBtn = isTsar ? (
    <Button
      size="small"
      variant="contained"
      color="secondary"
      disabled={ftlRemainingSkips === 0 || ftlCzarLocked || showFtlReveal}
      onClick={() => socket.emit("ftlSkip")}
      sx={{ alignSelf: "center", minWidth: 80, mt: 0.5 }}
    >
      Skip ({ftlRemainingSkips})
    </Button>
  ) : null;

  const reportButton = (
    <IconButton
      size="small"
      onClick={(e: React.MouseEvent<HTMLElement>) => {
        setReportAnchorEl(e.currentTarget);
        setReportPanelOpen(true);
      }}
      sx={{
        position: "absolute",
        top: 4,
        right: 4,
        color: "#f44336",
        bgcolor: "rgba(255,255,255,0.6)",
        "&:hover": { bgcolor: "rgba(255,255,255,0.85)" },
        zIndex: 1,
        p: 0.5,
      }}
    >
      <ReportProblemOutlinedIcon sx={{ fontSize: "1rem" }} />
    </IconButton>
  );

  // Versus has no czar: the question is the group's, so skipping it is a group vote.
  const isVersusTurn = turnMode === TurnMode.STANDARD_VERSUS;

  const skipVoteLabel = hasVotedSkip
    ? `Skip ✓ (${skipVoters.length}/${skipVotesTarget})`
    : `Skip (${skipVoters.length}/${skipVotesTarget})`;

  // ─── Unified game content renderer ────────────────────────────────────
  // Single decision point for which mode/phase to render.
  // On mobile: includes QuestionHeader, skip buttons, and wrapping Stack.
  // On desktop: returns raw content (QuestionHeader + skip buttons are above).
  const renderGameContent = (mobile: boolean): React.ReactNode => {
    if (!initialStateReceived) return null;

    const mobilePad = { px: 2, pt: "64px", pb: 3 };

    // ── Intermission ──────────────────────────────────────────────────────
    // Highest priority in the chain: an admin message holds the whole lobby between two turns,
    // so it must cover whatever mode state is paused underneath it.
    if (intermission) {
      const panel = (
        <IntermissionPanel
          payload={intermission}
          acknowledged={intermissionAcks}
          totalPlayers={intermissionTotal || totalPlayers}
          hasAcknowledged={intermissionAcks.includes(props.playerId)}
          isHost={props.isHost}
          onAcknowledge={() => socket.emit("intermissionOk")}
          onSkip={() => socket.emit("intermissionSkip")}
          mobile={mobile}
        />
      );
      if (mobile) return <Stack alignItems="center" justifyContent="center" sx={{ ...mobilePad, width: "100%", minHeight: "100dvh" }}>{panel}</Stack>;
      return panel;
    }

    // ── Results panels ────────────────────────────────────────────────────

    if (showFtlStreakResults && ftlStreakResults) {
      const panel = (
        <FtlStreakResultsPanel
          streakResults={ftlStreakResults}
          players={props.players}
          isMobile={mobile}
          waitForHost={props.waitForHost}
          isHost={props.isHost}
          isReady={props.isReady}
          readyPlayerIds={props.readyPlayerIds}
          totalPlayers={totalPlayers}
          onReadyToggle={props.onReadyToggle}
        />
      );
      if (mobile) return <Stack spacing={2} alignItems="center" justifyContent="center" sx={{ ...mobilePad, width: "100%", minHeight: "100dvh" }}>{panel}</Stack>;
      return panel;
    }

    if (showHerdStreakResults && herdStreakResults) {
      const panel = (
        <HerdStreakResultsPanel
          streakResults={herdStreakResults}
          players={props.players}
          isMobile={mobile}
          waitForHost={props.waitForHost}
          isHost={props.isHost}
          isReady={props.isReady}
          readyPlayerIds={props.readyPlayerIds}
          totalPlayers={totalPlayers}
          onReadyToggle={props.onReadyToggle}
        />
      );
      if (mobile) return <Stack spacing={2} alignItems="center" justifyContent="center" sx={{ ...mobilePad, width: "100%", minHeight: "100dvh" }}>{panel}</Stack>;
      return panel;
    }

    if (showRrResults && rrResults) {
      const panel = (
        <ReverseRoundResultsPanel
          results={rrResults}
          cues={rrCues}
          players={props.players}
          waitForHost={props.waitForHost}
          isHost={props.isHost}
          isReady={props.isReady}
          readyPlayerIds={props.readyPlayerIds}
          totalPlayers={totalPlayers}
          onReadyToggle={props.onReadyToggle}
        />
      );
      if (mobile) return (
        <Stack spacing={2} alignItems="center" sx={{ ...mobilePad, width: "100%", height: "100dvh", overflowY: "auto" }}>
          {rrQuestion && <QuestionHeader isMobile question={rrQuestion} tsarName={props.playerName} isTsar={true} />}
          {panel}
        </Stack>
      );
      return panel;
    }

    if (showPicassoResults) {
      const panel = (
        <PicassoResults
          results={picassoResults!}
          waitForHost={props.waitForHost}
          isHost={props.isHost}
          isReady={props.isReady}
          readyPlayerIds={props.readyPlayerIds}
          totalPlayers={totalPlayers}
          onReadyToggle={props.onReadyToggle}
          onNextTurn={() => socket.emit("nextTurn")}
        />
      );
      if (mobile) return (
        <Stack spacing={2} sx={{ ...mobilePad, width: "100%", minHeight: "100dvh" }}>
          {picassoQuestion && <QuestionHeader isMobile question={picassoQuestion} tsarName={props.playerName} isTsar={true} />}
          {panel}
        </Stack>
      );
      return panel;
    }

    if (showVersusResults && versusResults) {
      const panel = (
        <VersusResultsPanel
          results={versusResults}
          viewerId={props.playerId}
          players={props.players}
          isMobile={mobile}
          waitForHost={props.waitForHost}
          isHost={props.isHost}
          isReady={props.isReady}
          readyPlayerIds={props.readyPlayerIds}
          totalPlayers={totalPlayers}
          onReadyToggle={props.onReadyToggle}
        />
      );
      if (mobile) return (
        <Stack spacing={2} alignItems="center" justifyContent="flex-start" sx={{ ...mobilePad, width: "100%", minHeight: "100dvh" }}>
          {/* Everyone answered truthfully → forTsar phrasing for the whole group. */}
          <QuestionHeader isMobile question={question} tsarName={tsarName} isTsar={true} />
          {panel}
        </Stack>
      );
      return panel;
    }

    // ── Active mode panels ────────────────────────────────────────────────

    if (turnMode === TurnMode.FOLLOW_THE_LEADER) {
      const turnInfoRow = (
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ px: 0.5 }}>
          <Typography variant="body2" color="text.secondary">
            {t("round")} {currentRound}/{roundLimit} &middot; {t("turn")} {(ftlStreakState?.streakIndex ?? 0) + 1}/5
          </Typography>
          {ftlCzarLocked && !isTsar && (() => {
            const isRevealed = showFtlReveal && ftlTurnResultData;
            const wasElim = isRevealed && ftlTurnResultData!.eliminations.includes(props.playerId);
            const text = isRevealed
              ? wasElim ? "You got trampled!" : ftlIsAlive ? "You survived!" : "Spectating..."
              : "Leader has chosen!";
            const color = isRevealed
              ? wasElim ? "#e75151" : ftlIsAlive ? "#4caf50" : "text.secondary"
              : "#e75151";
            return <Typography variant="body2" fontWeight="bold" color={color}>{text}</Typography>;
          })()}
          <Typography variant="h4" fontWeight="bold" color={ftlCzarLocked ? "#e75151" : "primary.main"}>
            {ftlCzarLocked ? ftlCzarCountdown : (ftlTimeLeft > 0 ? ftlTimeLeft : "")}
          </Typography>
        </Stack>
      );
      if (mobile) return (
        <Stack spacing={2} sx={mobilePad}>
          <QuestionHeader isMobile question={question} tsarName={tsarName} isTsar={isTsar} />
          {ftlCzarSkipBtn}
          {turnInfoRow}
          {renderFtlPanel(true)}
        </Stack>
      );
      return <>{turnInfoRow}{renderFtlPanel(false)}</>;
    }

    if (turnMode === TurnMode.RUN_WITH_THE_HERD) {
      const turnInfoRow = (
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ px: 0.5 }}>
          <Typography variant="body2" color="text.secondary">
            {t("round")} {currentRound}/{roundLimit} &middot; {t("turn")} {(herdStreakState?.streakIndex ?? 0) + 1}/4
          </Typography>
          {showHerdReveal && herdTurnResultData && (() => {
            const wasElim = herdTurnResultData.eliminations.includes(props.playerId);
            const text = herdTurnResultData.wasSplit ? "Herd split!" : wasElim ? "You got trampled!" : herdIsAlive ? "You ran with the herd!" : "Spectating...";
            const color = herdTurnResultData.wasSplit ? "#e8a838" : wasElim ? "#e75151" : herdIsAlive ? "#4caf50" : "text.secondary";
            return <Typography variant="body2" fontWeight="bold" color={color}>{text}</Typography>;
          })()}
          <Typography variant="h4" fontWeight="bold" color="primary.main">
            {herdTimeLeft > 0 ? herdTimeLeft : ""}
          </Typography>
        </Stack>
      );
      if (mobile) return (
        <Stack spacing={2} sx={mobilePad}>
          {herdStreakState?.question && <QuestionHeader isMobile question={herdStreakState.question} tsarName={props.playerName} isTsar={true} />}
          {herdSkipBtn}
          {turnInfoRow}
          {renderHerdPanel(true)}
        </Stack>
      );
      return <>{turnInfoRow}{renderHerdPanel(false)}</>;
    }

    if (turnMode === TurnMode.REVERSE_ROUND) {
      const turnInfoRow = (
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ px: 0.5 }}>
          <Typography variant="body2" color="text.secondary">
            {t("round")} {currentRound}/{roundLimit} &middot; {t("rr_mode_label", "Reverse Round")}
          </Typography>
          <Typography variant="h4" color="primary.main" fontWeight="bold">
            {timeLeft > 0 ? timeLeft : ""}
          </Typography>
        </Stack>
      );
      if (mobile) return (
        <Stack spacing={2} sx={mobilePad}>
          {rrQuestion && <QuestionHeader isMobile question={rrQuestion} tsarName={props.playerName} isTsar={true} />}
          {turnInfoRow}
          {renderRrPanel(true)}
        </Stack>
      );
      return <>{turnInfoRow}{renderRrPanel(false)}</>;
    }

    if (turnMode === TurnMode.PICASSO && picassoStage === 1) {
      const picassoSkipBtn = (
        <Button
          size="small"
          variant="contained"
          color="secondary"
          onClick={() => socket.emit(hasVotedSkip ? "voteUnSkip" : "voteSkip")}
          sx={{ alignSelf: "center", minWidth: 110, mt: 0.5 }}
        >
          {skipVoteLabel}
        </Button>
      );
      const turnInfoRow = (
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ px: 0.5 }}>
          <Typography variant="body2" color="text.secondary">
            {t("round")} {currentRound}/{roundLimit} &middot; {t("picasso_game_mode_label", "Picasso")}
          </Typography>
          {picassoImposterAccepted === true && picassoImposterMission && (
            <Typography variant="body2" sx={{ color: "#f44336", fontWeight: "bold", fontStyle: "italic" }}>
              Impersonating {picassoImposterMission.targetPlayerName}
            </Typography>
          )}
          <Typography variant="h4" color="primary.main" fontWeight="bold">
            {timeLeft > 0 ? timeLeft : ""}
          </Typography>
        </Stack>
      );
      const canvas = (
        <PicassoCanvas
          key={picassoCanvasKey}
          ref={picassoCanvasRef}
          onExport={(svg) => socket.emit("picassoSubmitDrawing", { drawingSvg: svg })}
          onUnsubmit={() => socket.emit("picassoUnsubmit")}
          imposterTarget={picassoImposterMission?.targetPlayerName}
          onImposterDecision={(accepted) => {
            setPicassoImposterAccepted(accepted);
            socket.emit("picassoImposterDecision", { accepted });
          }}
          submittedCount={picassoSubmittedIds.length}
          totalPlayers={totalPlayers}
        />
      );
      if (mobile) return (
        <Stack spacing={2} alignItems="stretch" justifyContent="center" sx={{ ...mobilePad, minHeight: "100dvh" }}>
          {picassoQuestion && <QuestionHeader isMobile question={picassoQuestion} tsarName={props.playerName} isTsar={true} />}
          {picassoSkipBtn}
          {turnInfoRow}
          {canvas}
        </Stack>
      );
      return <>{turnInfoRow}{canvas}</>;
    }

    if (turnMode === TurnMode.PICASSO && picassoGuessAssignment) {
      const turnInfoRow = (
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ px: 0.5 }}>
          <Typography variant="body2" color="text.secondary">
            {t("round")} {currentRound}/{roundLimit} &middot; {t("picasso_game_mode_label", "Picasso")}
          </Typography>
          <Typography variant="h4" color="primary.main" fontWeight="bold">
            {timeLeft > 0 ? timeLeft : ""}
          </Typography>
        </Stack>
      );
      const reveal = (
        <PicassoImposterReveal
          drawingA={picassoGuessAssignment.drawingA}
          drawingB={picassoGuessAssignment.drawingB}
          targetPlayerName={picassoGuessAssignment.targetPlayerName}
          playerId={props.playerId}
          onSelect={(vote) => { picassoVoteRef.current = vote; }}
          onVote={(vote) => { picassoVoteRef.current = vote; socket.emit("picassoVote", { vote }); }}
          revealResult={showPicassoReveal ? picassoRevealDataRef.current : null}
          onRevealComplete={() => {
            setShowPicassoReveal(false);
            setPicassoStage(null);
            setPicassoGuessAssignment(null);
            setTurnMode(TurnMode.STANDARD);
            setShowPicassoResults(true);
          }}
        />
      );
      if (mobile) return (
        <Stack spacing={2} alignItems="stretch" justifyContent="center" sx={{ ...mobilePad, minHeight: "100dvh" }}>
          {picassoQuestion && <QuestionHeader isMobile question={picassoQuestion} tsarName={props.playerName} isTsar={true} />}
          {turnInfoRow}
          {reveal}
        </Stack>
      );
      return <>{turnInfoRow}{reveal}</>;
    }

    if (turnMode === TurnMode.PICASSO) {
      const waiting = (
        <Typography color="grey.500" fontStyle="italic" textAlign="center">
          Waiting...
        </Typography>
      );
      if (mobile) return (
        <Stack spacing={2} alignItems="stretch" justifyContent="center" sx={{ ...mobilePad, minHeight: "100dvh" }}>
          {picassoQuestion && <QuestionHeader isMobile question={picassoQuestion} tsarName={props.playerName} isTsar={true} />}
          {waiting}
        </Stack>
      );
      return waiting;
    }

    // ── Standard mode ─────────────────────────────────────────────────────

    if (!showLatestResults) {
      const turnInfoRow = (
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ px: 0.5 }}>
          <Typography variant="body2" color="text.secondary">
            {/* Versus has no czar rotation, so a round IS a single question — say so. */}
            {t(turnMode === TurnMode.STANDARD_VERSUS ? "question" : "round")} {currentRound} / {roundLimit}
          </Typography>
          <Typography variant="h4" color="primary.main" fontWeight="bold">
            {timeLeft > 0 ? timeLeft : ""}
          </Typography>
        </Stack>
      );
      if (mobile) return (
        <Stack spacing={2} sx={mobilePad}>
          <Box sx={{ position: "relative" }}>
            {/* In versus everyone answers truthfully → always the first-person (forTsar) phrasing. */}
            <QuestionHeader isMobile question={question} tsarName={tsarName} isTsar={isTsar || turnMode === TurnMode.STANDARD_VERSUS} />
            {turnMode === TurnMode.STANDARD && reportButton}
          </Box>
          {turnInfoRow}
          <SequenceBar
            key={"sb-" + turnNonce}
            sequence={sequence}
            remainingSkips={isVersusTurn ? 1 : remainingSkips}
            reset={() => reset()}
            canSkip={isVersusTurn || isTsar}
            decreaseRemainingSkips={handleDecreaseRemainingSkips}
            onSkip={isVersusTurn ? () => socket.emit(hasVotedSkip ? "voteUnSkip" : "voteSkip") : undefined}
            skipLabel={isVersusTurn ? skipVoteLabel : undefined}
            cue1={cue1} cue2={cue2} cue3={cue3} cue4={cue4} cue5={cue5}
            isMobile={true}
            isShuffling={isShuffling}
            initialSubmitted={restoredSubmitted}
            editStartVersion={sequenceEditVersion}
          />
        </Stack>
      );
      return (
        <>
          {turnInfoRow}
          <SequenceBar
            key={"sb-" + turnNonce}
            sequence={sequence}
            remainingSkips={isVersusTurn ? 1 : remainingSkips}
            reset={() => reset()}
            canSkip={isVersusTurn || isTsar}
            decreaseRemainingSkips={handleDecreaseRemainingSkips}
            onSkip={isVersusTurn ? () => socket.emit(hasVotedSkip ? "voteUnSkip" : "voteSkip") : undefined}
            skipLabel={isVersusTurn ? skipVoteLabel : undefined}
            cue1={cue1} cue2={cue2} cue3={cue3} cue4={cue4} cue5={cue5}
            isShuffling={isShuffling}
            initialSubmitted={restoredSubmitted}
            editStartVersion={sequenceEditVersion}
          />
        </>
      );
    }

    // Standard results — different components for mobile/desktop
    if (mobile) return (
      <Stack spacing={2} sx={{ minHeight: "100dvh", pt: "64px", pb: 2, px: 2 }}>
        <Box sx={{ position: "relative" }}>
          <QuestionHeader isMobile question={question} tsarName={tsarName} isTsar={isTsar} />
          {reportButton}
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <MobileResults
            cues={[cue1, cue2, cue3, cue4, cue5]}
            isHost={props.isHost}
            isTsar={isTsar}
            tsarId={tsarId}
            playerId={props.playerId}
            results={results}
            question={question}
            waitForHost={props.waitForHost}
            readyPlayerIds={props.readyPlayerIds}
            isReady={props.isReady}
            onReadyToggle={props.onReadyToggle}
            totalPlayers={totalPlayers}
          />
        </Box>
      </Stack>
    );
    return (
      <ResultsDialog
        inline
        isOpen={true}
        cues={[cue1, cue2, cue3, cue4, cue5]}
        isHost={props.isHost}
        isTsar={isTsar}
        tsarId={tsarId}
        playerId={props.playerId}
        results={results}
        question={question}
        waitForHost={props.waitForHost}
        readyPlayerIds={props.readyPlayerIds}
        isReady={props.isReady}
        onReadyToggle={props.onReadyToggle}
        totalPlayers={totalPlayers}
      />
    );
  };

  return (
    <>
      <DragDropContext onDragStart={onSequenceDragStart} onDragEnd={onDragEnd}>
        {isMobile ? (
          <>
            <Box
              id="box1"
              sx={{
                height: "100dvh",
                overflowX: "hidden",
                overflowY: "auto",
              }}
              className="mobileGameView"
            >
              {renderGameContent(true)}
            </Box>
          </>
        ) : (
          <>
            <Box
              id="box1"
              sx={{
                height: "100vh",
                overflow: "auto",
              }}
            >
              <Stack alignItems="center" sx={{ minHeight: "100dvh", py: 4 }}>
                <Stack direction="row" alignItems="stretch" spacing={2} sx={{ my: "auto" }}>
                  {/* Player list docked to the left of the input */}
                  <Stack spacing={1} sx={{ minHeight: 0, overflow: "hidden", alignSelf: "flex-start", position: "sticky", top: "1rem" }}>
                    <Paper sx={{ p: 1, minWidth: "8.75rem", maxWidth: "11.25rem", flex: 1, minHeight: 0, maxHeight: "60vh", overflowY: "auto" }}>
                      <Stack spacing={0.5}>
                        {(() => {
                          const allPids = Object.keys(props.players);
                          return allPids
                            .slice().sort((a, b) => props.players[b].score - props.players[a].score)
                            .map((playerId) => (
                            <PlayerCard
                              key={playerId}
                              inGame
                              color={getPlayerColor(allPids.indexOf(playerId))}
                              name={props.players[playerId].name}
                              score={props.players[playerId].score}
                              isHost={props.hostId === playerId}
                              isTsar={tsarId === playerId}
                              isSelf={playerId === props.playerId}
                              isReady={
                                turnMode === TurnMode.PICASSO && picassoStage === 1
                                  ? picassoSubmittedIds.includes(playerId)
                                  : !props.waitForHost ? props.readyPlayerIds.includes(playerId) : undefined
                              }
                              canKick={props.isHost && playerId !== props.playerId}
                              onKick={() => setKickTarget(playerId)}
                            />
                          ));
                        })()}
                      </Stack>
                    </Paper>
                    <Paper sx={{ p: 0.75, minWidth: "8.75rem", maxWidth: "11.25rem" }}>
                      <Stack spacing={0.75}>
                        <Stack direction="row" alignItems="center" spacing={0.25}>
                          <Typography
                            variant="caption"
                            sx={{
                              flex: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              filter: isCodeVisible ? "" : "blur(5px)",
                              userSelect: isCodeVisible ? "auto" : "none",
                              transition: "filter 0.2s",
                            }}
                          >
                            {lobbyKey}
                          </Typography>
                          <IconButton size="small" sx={{ p: 0.25 }} onClick={() => setIsCodeVisible((v) => !v)}>
                            {isCodeVisible ? <VisibilityIcon sx={{ fontSize: "0.95rem" }} /> : <VisibilityOffIcon sx={{ fontSize: "0.95rem" }} />}
                          </IconButton>
                          <IconButton size="small" sx={{ p: 0.25, color: linkCopied ? "success.main" : undefined }} onClick={copyInviteLink}>
                            {linkCopied ? <CheckCircleIcon sx={{ fontSize: "0.95rem" }} /> : <ContentCopyIcon sx={{ fontSize: "0.95rem" }} />}
                          </IconButton>
                        </Stack>
                        <Button
                          color="error"
                          variant="outlined"
                          size="small"
                          fullWidth
                          onClick={() => setLeaveDialogOpen(true)}
                        >
                          Leave
                        </Button>
                      </Stack>
                    </Paper>
                  </Stack>

                  {/* Center column: question → round/timer row → SequenceBar OR FTL OR RR OR inline results */}
                  <Stack spacing={1.5} sx={{ width: "55vw", maxWidth: "42.5rem" }}>
                    <Stack direction="row" alignItems="flex-start" spacing={1}>
                      <Box sx={{ position: "relative", flex: 1 }}>
                        <QuestionHeader
                          question={
                            (turnMode === TurnMode.PICASSO || showPicassoResults) && picassoQuestion ? picassoQuestion
                            : (turnMode === TurnMode.REVERSE_ROUND || showRrResults) && rrQuestion ? rrQuestion
                            : (turnMode === TurnMode.RUN_WITH_THE_HERD || showHerdStreakResults) && herdStreakState?.question ? herdStreakState.question
                            : question
                          }
                          tsarName={
                            (turnMode === TurnMode.PICASSO || showPicassoResults) ? props.playerName
                            : (turnMode === TurnMode.REVERSE_ROUND || showRrResults) ? props.playerName
                            : (turnMode === TurnMode.RUN_WITH_THE_HERD || showHerdStreakResults) ? props.playerName
                            : tsarName
                          }
                          isTsar={
                            (turnMode === TurnMode.PICASSO || showPicassoResults) ? true
                            : (turnMode === TurnMode.REVERSE_ROUND || showRrResults) ? true
                            : (turnMode === TurnMode.RUN_WITH_THE_HERD || showHerdStreakResults) ? true
                            : (turnMode === TurnMode.STANDARD_VERSUS || showVersusResults) ? true
                            : isTsar
                          }
                        />
                        {turnMode === TurnMode.STANDARD && reportButton}
                      </Box>
                      {/* FTL czar skip — next to question header, same height */}
                      {turnMode === TurnMode.FOLLOW_THE_LEADER && isTsar && (
                        <Button
                          variant="contained"
                          color="secondary"
                          disabled={ftlRemainingSkips === 0 || ftlCzarLocked || showFtlReveal}
                          onClick={() => socket.emit("ftlSkip")}
                          sx={{ alignSelf: "stretch", minWidth: 80, flexShrink: 0 }}
                        >
                          Skip ({ftlRemainingSkips})
                        </Button>
                      )}
                      {/* Herd vote skip — next to question header, same height */}
                      {turnMode === TurnMode.RUN_WITH_THE_HERD && (
                        <Button
                          variant="contained"
                          color="secondary"
                          disabled={showHerdReveal}
                          onClick={() => socket.emit(hasVotedSkip ? "voteUnSkip" : "voteSkip")}
                          sx={{ alignSelf: "stretch", minWidth: 110, flexShrink: 0 }}
                        >
                          {hasVotedSkip ? `Skip ✓ (${skipVoters.length}/${skipVotesTarget})` : `Skip (${skipVoters.length}/${skipVotesTarget})`}
                        </Button>
                      )}
                      {/* Picasso vote skip — next to question header, same height */}
                      {turnMode === TurnMode.PICASSO && picassoStage === 1 && (
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => socket.emit(hasVotedSkip ? "voteUnSkip" : "voteSkip")}
                          sx={{ alignSelf: "stretch", minWidth: 110, flexShrink: 0 }}
                        >
                          {hasVotedSkip ? `Skip ✓ (${skipVoters.length}/${skipVotesTarget})` : `Skip (${skipVoters.length}/${skipVotesTarget})`}
                        </Button>
                      )}
                    </Stack>
                    {renderGameContent(false)}
                  </Stack>
                </Stack>
              </Stack>
            </Box>
          </>
        )}
      </DragDropContext>
      <TurnBurst
        isVisible={showIntro && !showLatestResults && !showVersusResults}
        isTsar={isTsar}
        tsarName={tsarName}
        onDismiss={() => setShowIntro(false)}
        mode={turnMode === TurnMode.PICASSO ? (picassoGuessAssignment ? "PICASSO_GALLERY" : "PICASSO") : turnMode === TurnMode.FOLLOW_THE_LEADER ? "FOLLOW_THE_LEADER" : turnMode === TurnMode.RUN_WITH_THE_HERD ? "RUN_WITH_THE_HERD" : turnMode === TurnMode.STANDARD_VERSUS ? "STANDARD_VERSUS" : turnMode === TurnMode.REVERSE_ROUND ? (rrStage === 2 ? "REVERSE_ROUND_GUESS" : "REVERSE_ROUND") : "STANDARD"}
      />
      <ReportPanel
        open={reportPanelOpen}
        anchorEl={reportAnchorEl}
        onClose={() => { setReportPanelOpen(false); setReportAnchorEl(null); }}
        question={
          (turnMode === TurnMode.RUN_WITH_THE_HERD || showHerdStreakResults) && herdStreakState?.question
            ? herdStreakState.question
            : (turnMode === TurnMode.REVERSE_ROUND || showRrResults) && rrQuestion ? rrQuestion : question
        }
        cues={
          (turnMode === TurnMode.RUN_WITH_THE_HERD || showHerdStreakResults) && herdStreakState?.options
            ? herdStreakState.options
            : (turnMode === TurnMode.REVERSE_ROUND || showRrResults) && rrCues.length > 0 ? rrCues : [cue1, cue2, cue3, cue4, cue5]
        }
        socket={socket}
        isTsar={isTsar}
        tsarName={tsarName}
      />
      {/* Mobile: top-right Leave + top-left Players — hidden during intro */}
      {isMobile && !showIntro && (
        <>
          {/* Leave button — top right */}
          <Button
            color="error"
            variant="outlined"
            size="small"
            sx={{
              position: "fixed",
              top: 12,
              right: 12,
              zIndex: 1001,
              bgcolor: "rgba(0,0,0,0.25)",
              backdropFilter: "blur(4px)",
            }}
            onClick={() => setLeaveDialogOpen(true)}
          >
            Leave
          </Button>
          {/* Players icon — top left */}
          <IconButton
            sx={{
              position: "fixed",
              top: 12,
              left: 12,
              zIndex: 1001,
              color: "white",
              bgcolor: "rgba(0,0,0,0.25)",
              backdropFilter: "blur(4px)",
              border: "1px solid rgba(255,255,255,0.35)",
            }}
            onClick={() => setPlayersOpen((o) => !o)}
          >
            <PeopleAltIcon />
          </IconButton>
          {/* Players overlay panel */}
          {playersOpen && (
            <Paper
              elevation={6}
              sx={{
                position: "fixed",
                top: 60,
                left: 12,
                zIndex: 1000,
                width: "70vw",
                maxWidth: 280,
                maxHeight: "60vh",
                overflow: "auto",
                p: 1.5,
              }}
            >
              <Stack spacing={0.5}>
                <Stack direction="row" alignItems="center" spacing={0.5}>
                  <Typography variant="body2" color="text.secondary">Code:</Typography>
                  <Typography variant="body2" fontWeight="bold" sx={{ flex: 1 }}>{lobbyKey}</Typography>
                  <IconButton size="small" sx={{ p: 0.25 }} onClick={() => navigator.clipboard.writeText(inviteLink)}>
                    <ContentCopyIcon sx={{ fontSize: "0.9rem" }} />
                  </IconButton>
                </Stack>
                <Divider />
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Typography variant="subtitle1" fontWeight="bold">Players</Typography>
                  <IconButton size="small" onClick={() => setPlayersOpen(false)}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Stack>
                {(() => {
                  const allPids = Object.keys(props.players);
                  return Object.entries(props.players).map(([id, player]) => (
                  <Stack key={id} direction="row" alignItems="center" spacing={0.75} sx={{ py: 0.5 }}>
                    <Stack direction="row" alignItems="center" spacing={0.5} sx={{ flex: 1, minWidth: 0 }}>
                      <PlayerAvatar color={getPlayerColor(allPids.indexOf(id))} size={Math.round(24 * uiScale)} />
                      {id === props.hostId
                        ? <FaCrown style={{ color: "gold", flexShrink: 0, fontSize: "0.85em" }} />
                        : props.isHost && id !== props.playerId
                          ? <CloseIcon
                              sx={{ fontSize: "0.85em", flexShrink: 0, color: "text.disabled", cursor: "pointer", "&:hover": { color: "error.main" } }}
                              onClick={() => setKickTarget(id)}
                            />
                          : <Box sx={{ width: "0.85em", flexShrink: 0 }} />}
                      <Typography
                        noWrap
                        sx={{
                          minWidth: 0,
                          color: (id === tsarId || id === props.playerId) ? "primary.main" : "inherit",
                          fontWeight: id === props.playerId ? "bold" : undefined,
                        }}
                      >
                        {player.name}
                      </Typography>
                      {id === tsarId && (
                        <Chip label="T" size="small" color="primary" sx={{ flexShrink: 0, height: "1.4em", fontSize: "0.6em" }} />
                      )}
                    </Stack>
                    <Typography variant="body2" color="text.secondary" sx={{ flexShrink: 0 }}>
                      {player.score}
                    </Typography>
                  </Stack>
                ));
                })()}
              </Stack>
            </Paper>
          )}
        </>
      )}
      {/* Leave confirmation dialog */}
      {leaveDialogOpen && (
        <Dialog open onClose={() => setLeaveDialogOpen(false)}>
          <DialogTitle>Leave game?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to leave? You'll be removed from the lobby.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setLeaveDialogOpen(false)}>Stay</Button>
            <Button
              color="error"
              variant="contained"
              onClick={() => {
                socket.emit("leaveLobby");
                sessionStorage.removeItem("playerId");
                sessionStorage.removeItem("lobbyKey");
                history.push("/play");
              }}
            >
              Leave
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {/* Kick confirmation dialog */}
      {kickTarget !== null && (
        <Dialog open onClose={() => setKickTarget(null)}>
          <DialogTitle>Kick player?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Kick <strong>{props.players[kickTarget]?.name}</strong> from the game?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setKickTarget(null)}>Cancel</Button>
            <Button
              color="error"
              variant="contained"
              onClick={() => {
                socket.emit("kickPlayer", { targetPlayerId: kickTarget });
                setKickTarget(null);
              }}
            >
              Kick
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {/* DC overlay */}
      <Backdrop open={props.wasDCed} sx={{ zIndex: 9999, bgcolor: "rgba(0,0,0,0.6)", flexDirection: "column", gap: 2 }}>
        <WifiOffIcon sx={{ fontSize: 80, color: "white" }} />
        <Typography variant="h5" color="white" textAlign="center">
          Connection lost - trying to get you back in…
        </Typography>
        {props.reconnectStatus && (
          <Typography variant="body2" color="white" textAlign="center" sx={{ opacity: 0.8 }}>
            {props.reconnectStatus}
          </Typography>
        )}
        <Button variant="contained" sx={{ mt: 2 }} onClick={props.rejoin}>
          Tap to reconnect
        </Button>
      </Backdrop>
    </>
  );
}
